export default "__VITE_ASSET__a5bba617__"